function displaycontentlink() {
  var dots = document.getElementById("dots");
  var moreText = document.getElementById("more");
  var readmoreText = document.getElementById("readmore");
  if (dots.style.display === "none") {
    dots.style.display = "inline";
    readmoreText.innerHTML = "Read more"; 
    moreText.style.display = "none";
  } else {
    dots.style.display = "none";
    readmoreText.innerHTML = "Read less";
    moreText.style.display = "inline";

  }
}
// jQuery("#readmore").click(function(){
//   console.log("in readmore");
//       jQuery("#more").fadeIn("slow");
//   console.log("after animate");
// });
jQuery(".readmore").click(function() { if(jQuery(this).html() == "Read more"){
    $('html, body').animate({
        scrollTop: $(".rich-text__wrapper").offset().top -150
    }, 500);}
});
jQuery(document).ready(function(){
    jQuery('.hover-menu').hover(function(){
        jQuery(this).attr('open', '');	
    });
   jQuery('.hover-menu').on('mouseleave',function(){
        jQuery(this).removeAttr('open');	
    });
  jQuery("#shopnow").click(function(){
  //your logic on click
  // alert("clicked");
  console.log("clicked");
})

});
  // For Validation
        jQuery("body").on("blur","#fieldname1_1, #fieldname2_1, #fieldname3_1",function(){
            jQuery('#mix-calculator .error').hide();
            jQuery('.cpefb_error').text('');
            var hasError = false;
            var errorMsg = "";
            if(jQuery(this).hasClass("required")) {
                if(jQuery(this).val()==""){
                    hasError = true;
                    errorMsg = "This field is required";
                }
            }
            var currentField = parseFloat(jQuery(this).val());
            if(isNaN(currentField) && !hasError) {
                currentField = 0;
                hasError = true;
                errorMsg = "Please enter a valid number.";
            }else if(!hasError){
                var max = jQuery(this).attr('max');
                var min = jQuery(this).attr('min');
                if(typeof max !== "undefined" && typeof min !== "undefined" && (currentField > max || currentField < min)) {
                    hasError = true;
                    errorMsg = "Please enter a value less than or equal to 100.";
                }
            }
            if(hasError) {
                var errorId = '#'+jQuery(this).attr('id')+'-error';
                jQuery(errorId).text(errorMsg)
                jQuery(errorId).show();
            }
        });
        // Calculation logic
        jQuery("body").on("change keyup","#fieldname1_1, #fieldname2_1, #fieldname3_1",function(){
            var fieldname1_1 = parseFloat(jQuery('#fieldname1_1').val());
            if(isNaN(fieldname1_1))
                fieldname1_1 = 0;
            var fieldname2_1 = parseFloat(jQuery('#fieldname2_1').val());
            if(isNaN(fieldname2_1))
                fieldname2_1 = 0;
            var fieldname3_1 = parseFloat(jQuery('#fieldname3_1').val());
            if(isNaN(fieldname3_1))
                fieldname3_1 = 0;
            var fieldname4_1 = fieldname1_1 / (100-(fieldname2_1+fieldname3_1));
            var fieldname5_1 = fieldname4_1 * fieldname2_1;
            var fieldname6_1 = fieldname4_1 * fieldname3_1;
            var fieldname7_1 = fieldname1_1 + fieldname5_1 + fieldname6_1;
            jQuery('#fieldname5_1').val(fieldname5_1.toFixed(2));
            jQuery('#fieldname6_1').val(fieldname6_1.toFixed(2));
            jQuery('#fieldname7_1').val(fieldname7_1.toFixed(2));
        });

/* Restriction for Wholesale user below $500 + Hide Rebuy widgets code start here */

/* Config: all widgets to hide for wholesale users */
const wholesaleHiddenWidgets = [221831, 221833]; // 👈 add/remove IDs here

function waitForCartDrawer(callback) {
  var attempts = 0;
  var maxAttempts = 10;
  var interval = setInterval(function() {
    var drawer = document.querySelector('#rebuy-cart');
    if (drawer) {
      clearInterval(interval);
      callback(drawer);
    } else if (attempts >= maxAttempts) {
      clearInterval(interval);
      console.log('Cart drawer not found after waiting');
    }
    attempts++;
  }, 300);
}

function isWholesaleUser() {
  var tags = window.customerTags || [];
  var isWholesale = tags.includes('Wholesale') || tags.includes('wholesale');
  console.log('Checking wholesale user:', isWholesale);
  return isWholesale;
}

/* 🔥 Hide Rebuy widgets completely for wholesale users */
function hideRebuyWidgets(widgetIds) {
  if (!isWholesaleUser()) return;

  widgetIds.forEach(function(widgetId) {
    var attempts = 0;
    var maxAttempts = 15; // ~4.5s
    var interval = setInterval(function () {
      var widget = document.querySelector(`#rebuy-widget-${widgetId}`);

      if (widget) {
        console.log(`✅ Widget ${widgetId} found, removing from DOM`);
        widget.remove(); // 👈 completely remove
        clearInterval(interval);
      } else if (attempts >= maxAttempts) {
        console.log(`❌ Widget ${widgetId} not found after retries`);
        clearInterval(interval);
      }
      attempts++;
    }, 300);
  });
}

/* Cart Events */
document.addEventListener('rebuy:cart.ready', function(event) {
  console.log('Rebuy cart.ready event triggered');
  waitForCartDrawer(function(drawer) {
    checkCartRestrictions(event.detail.cart.cart, drawer);
    hideRebuyWidgets(wholesaleHiddenWidgets);
  });
});

document.addEventListener('rebuy:cart.change', function(event) {
  console.log('Rebuy cart.change event triggered');
  waitForCartDrawer(function(drawer) {
    checkCartRestrictions(event.detail.cart.cart, drawer);
    hideRebuyWidgets(wholesaleHiddenWidgets);
  });
});

/* Product Page */
document.addEventListener('DOMContentLoaded', function() {
  hideRebuyWidgets(wholesaleHiddenWidgets);
});

/* Wholesale Cart Restriction */
function checkCartRestrictions(cart, drawer) {
  if (!isWholesaleUser()) {
    var checkoutButton = drawer.querySelector('.rebuy-cart__checkout-button');
    if (checkoutButton) {
      checkoutButton.classList.remove('hidden');
      checkoutButton.style.display = '';
    }
    var message = document.getElementById('order-restriction-message');
    if (message) {
      message.style.display = 'none';
    }
    return;
  }

  var cartTotalCents = 0;
  if (cart.total_price_cents !== undefined) {
    cartTotalCents = parseInt(cart.total_price_cents, 10);
  } else if (cart.total_price !== undefined) {
    cartTotalCents = parseInt(cart.total_price, 10);
  } else if (cart.total !== undefined) {
    cartTotalCents = parseInt(cart.total, 10);
  } else {
    console.log('Cart total price not found');
  }

  var limitCents = 500 * 100; // $500 limit

  var checkoutButton = drawer.querySelector('.rebuy-cart__checkout-button');
  var headerTop = drawer.querySelector('[data-rebuy-cart-header-top]');
  var messageId = 'order-restriction-message';
  var message = document.getElementById(messageId);

  if (!message && headerTop) {
    message = document.createElement('div');
    message.id = messageId;
    message.style.color = 'red';
    message.style.padding = '8px 0 10px 0';
    message.style.fontWeight = 'bold';
    message.style.textAlign = 'center';
    headerTop.insertAdjacentElement('afterend', message);
  }

  if (cartTotalCents < limitCents) {
    if (checkoutButton) {
      checkoutButton.classList.add('hidden');
      checkoutButton.style.display = 'none';
    }
    if (message) {
      message.innerText = 'Orders above $500 only allowed for wholesale customers.';
      message.style.display = 'block';
    }
  } else {
    if (checkoutButton) {
      checkoutButton.classList.remove('hidden');
      checkoutButton.style.display = '';
    }
    if (message) {
      message.style.display = 'none';
    }
  }
}
/* Restriction for Wholesale user below $500 + Hide Rebuy widgets code end here */

document.addEventListener('DOMContentLoaded', function() {
  if (window.location.pathname === '/collections/shop') {
    window.location.href = '/pages/terp-spray-wax-liquidizer-terpenes';
  }
});